export default {
  getBrands (state) {
    return state.brands
  },
  getTypes (state) {
    return state.type
  },
  getSuppliers (state) {
    return state.suppliers
  },
  getQty (state) {
    return state.qty
  }
}
